export const primerApplePayOptions = {
    id: 'primer-apple-pay',
};
